import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CardModule } from 'primeng/card'
import { TooltipModule } from 'primeng/tooltip'
import { ProgressSpinnerModule } from 'primeng/progressspinner'

@Component({
  selector: 'app-affair-office-file',
  templateUrl: './affair-office-file.component.html',
  styleUrls: ['./affair-office-file.component.scss'],
  standalone: true,
  imports: [CommonModule, CardModule, TooltipModule, ProgressSpinnerModule],
})
export class AffairOfficeFileComponent {
  @Input() fullAffairDetails: any
  @Input() loading: boolean = false
  @Input() affair: any

  get hasSendSettings(): boolean {
    return (
      this.fullAffairDetails?.affairOfficeFile?.affairsSendSettings?.length > 0
    )
  }

  get hasIndicators(): boolean {
    return (
      this.fullAffairDetails?.affairOfficeFile?.officeFile
        ?.officesFilesIndicators?.length > 0
    )
  }

  get comment(): string | null {
    return this.fullAffairDetails?.affairOfficeFile?.officeFile?.comment ?? null
  }

  get sendSettings(): any[] {
    return this.fullAffairDetails?.affairOfficeFile?.affairsSendSettings ?? []
  }

  get indicators(): any[] {
    return (
      this.fullAffairDetails?.affairOfficeFile?.officeFile
        ?.officesFilesIndicators ?? []
    )
  }

  getRecipientsTooltip(setting: any): string {
    if (!setting.recipients?.length) {
      return setting.sendSetting.name
    }
    const emails = setting.recipients.map((r: any) => r.email).join('\n')
    return `${setting.sendSetting.name}\n\nDestinataires:\n${emails}`
  }

  getToRecipients(setting: any): any[] {
    if (!setting.recipients?.length) return []
    return setting.recipients.filter((r: any) => !r.isCc && r.type !== 'cc')
  }

  getCcRecipients(setting: any): any[] {
    if (!setting.recipients?.length) return []
    return setting.recipients.filter((r: any) => r.isCc || r.type === 'cc')
  }

  getEmailShort(email: string): string {
    if (!email) return ''
    const atIndex = email.indexOf('@')
    if (atIndex === -1) return email.substring(0, 10)
    const name = email.substring(0, atIndex)
    const domain = email.substring(atIndex + 1).split('.')[0]
    if (name.length > 8) {
      return name.substring(0, 8) + '..@' + domain
    }
    return name + '@' + domain
  }
}
